import React, { useContext } from "react";
import flow from "lodash/flow";
import fromPairs from "lodash/fromPairs";
import get from "lodash/get";
import zip from "lodash/zip";
import isEmpty from "lodash/isEmpty";
import { makeVisualization, retrieveChartData } from "views/components/aggregationbuilder/AggregationBuilder";
import useUserDateTime from "hooks/useUserDateTime";
import MapVisualization from "./MapVisualization";
import { extractSeries, formatSeries, getLeafsFromRows, getXLabelsFromLeafs } from "../ChartData";
import transformKeys from "../TransformKeys";
import RenderCompletionCallback from "../../widgets/RenderCompletionCallback";
const _arrayToMap = ([name, x, y]) => ({ name, x, y });
const _lastKey = (keys) => keys[keys.length - 1];
const _createSeriesWithoutMetric = (rows) => {
  const leafs = getLeafsFromRows(rows);
  const xLabels = getXLabelsFromLeafs(leafs);
  if (!isEmpty(xLabels)) {
    return { valuesBySeries: { "No metric defined": xLabels.map(() => null) }, xLabels };
  }
  return {};
};
const _formatSeriesForMap = (rowPivots) => {
  const fields = rowPivots.flatMap((rowPivot) => rowPivot.fields);
  return (result) => result.map(({ name, x, y }) => {
    const keys = x.map((k) => Object.fromEntries(k.slice(0, -1).map((key, idx) => [fields[idx], key])));
    const newX = x.map(_lastKey);
    const values = fromPairs(zip(newX, y).filter(([_, v]) => v !== void 0));
    return { keys, name, values };
  });
};
const WorldMapVisualization = makeVisualization(
  ({ config, data, editing, onChange, width, ...rest }) => {
    const { rowPivots } = config;
    const onRenderComplete = useContext(RenderCompletionCallback);
    const hasMetric = !isEmpty(config.series);
    const markerRadiusSize = !hasMetric ? 1 : void 0;
    const seriesExtractor = hasMetric ? extractSeries() : _createSeriesWithoutMetric;
    const { formatTime } = useUserDateTime();
    const pipeline = flow([
      transformKeys(config.rowPivots, config.columnPivots, formatTime),
      seriesExtractor,
      formatSeries,
      (results) => results.map(_arrayToMap),
      _formatSeriesForMap(rowPivots)
    ]);
    const rows = retrieveChartData(data);
    const series = pipeline(rows);
    const viewport = get(config, "visualizationConfig.viewport");
    const _onChange = (newViewport) => {
      if (editing) {
        onChange({
          zoom: newViewport.zoom,
          centerX: newViewport.center[0],
          centerY: newViewport.center[1]
        });
      }
    };
    return /* @__PURE__ */ React.createElement(
      MapVisualization,
      {
        ...rest,
        data: series,
        id: "world-map",
        viewport,
        width,
        onRenderComplete,
        markerRadiusSize,
        onChange: _onChange
      }
    );
  },
  "map"
);
export default WorldMapVisualization;
